import React, { useState } from 'react';
import { Link } from 'gatsby';
import Burger from './burger';
import Menu from './menu';

import logo from '@images/tcgl-logo.svg';

import './header.scss';

interface HeaderProps {
  className?: string;
}

export function Header({ className }: HeaderProps) {
  const [open, setOpen] = useState(false);

  return (
    <header className={`header ${className || ''}`}>
      <div className='inner-header'>
        <div className='header-icons'>
          <img className='header-icons-logo' src={logo} alt='TCGL logo' />
        </div>
        <div className='header-icons-rating burger-menu'>
          <Burger open={open} setOpen={setOpen} />
          <Menu open={open} />
        </div>
        <div className='header-icons-rating large-menu'>
          <ul className='menu-list'>
            <Link to={'/'} activeStyle={{ color: '#ec6842' }} className='menu-list-link'>
              Home
            </Link>
            <Link to={'/car-finance'} activeStyle={{ color: '#ec6842' }} className='menu-list-link'>
              Car Finance Claims
            </Link>
            <Link to={'/faq'} activeStyle={{ color: '#ec6842' }} className='menu-list-link'>
              FAQ
            </Link>
            <Link to={'/news'} activeStyle={{ color: '#ec6842' }} className='menu-list-link'>
              News
            </Link>
            <Link to={'/contact'} activeStyle={{ color: '#ec6842' }} className='menu-list-link'>
              Contact
            </Link>
          </ul>
        </div>
      </div>
    </header>
  );
}
